<template>
  <div class="edit-employee-payslip">
    <v-row>
      <v-col>
        <h1 class="text-left mx-4 my-1">Edit Employee Payslip</h1>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-card class="mx-2">
          <v-row>
            <v-col cols="12" md="6">
              <p class="text-left mx-4 font-weight-medium">
                Payroll Group :
                <strong>{{ payslip.payroll_group.title }}</strong>
              </p>
              <p class="text-left mx-4 font-weight-medium">
                Pay Period : <strong>{{ payslip.payslip_group.title }}</strong>
              </p>
              <p class="text-left mx-4 font-weight-medium">
                Employee Name : 
                <strong>{{
                  payslip.account.staff_hr_account.staff.full_name
                }}</strong>
              </p>
              <p class="text-left mx-4 font-weight-medium">
                Employee ID : 
                <strong>{{
                  payslip.account.staff_hr_account.staff.employee_id || "-"
                }}</strong>
              </p>
              <p class="text-left mx-4 font-weight-medium">
                Department : 
                <strong>{{
                  payslip.account.staff_hr_account.staff.deparment || "-"
                }}</strong>
              </p>
              <p class="text-left mx-4 font-weight-medium">
                Designation : 
                <strong>{{
                  payslip.account.staff_hr_account.staff.designation || "-"
                }}</strong>
              </p>
            </v-col>
            <v-col cols="12" md="6">
              <p class="text-left mx-4 font-weight-medium">
                Days Worked :
                <strong
                  >{{ payslip.monthly_attendance_data.worked_days || "-" }} /
                  {{
                    payslip.monthly_attendance_data.total_days || "-"
                  }}</strong
                >
              </p>
              <p class="text-left mx-4 font-weight-medium">
                Leaves :
                <strong
                  >{{ payslip.monthly_attendance_data.leaves || "-" }} ({{
                    payslip.monthly_attendance_data.unpaid_leaves || "-"
                  }}
                  Unpaid)</strong
                >
              </p>
              <p class="text-left mx-4 font-weight-medium">
                Half Days :
                <strong
                  >{{ payslip.monthly_attendance_data.half_days || "-" }} ({{
                    payslip.monthly_attendance_data.unpaid_half_days || "-"
                  }}
                  Unpaid)</strong
                >
              </p>
              <p class="text-left mx-4 font-weight-medium">
                Loss of Pay :
                <strong>
                  {{
                    Helper.currencyFormat(payslip.account.loss_of_pay) || "-"
                  }}
                </strong>
                <strong>{{
                  payslip.account.loss_of_pay ? "(Per day)" : ""
                }}</strong>
              </p>
              <p class="text-left mx-4 font-weight-medium">
                Overtime Hours :
                <strong
                  >{{
                    payslip.monthly_attendance_data.overtime_days
                      ? moment
                          .duration(
                            payslip.monthly_attendance_data.overtime_hours
                          )
                          .asSeconds() == 0
                        ? "-"
                        : Helper.secondsToHms(
                            moment
                              .duration(
                                payslip.monthly_attendance_data.overtime_hours
                              )
                              .asSeconds()
                          )
                      : "-"
                  }}
                </strong>
                <strong
                  >({{
                    payslip.monthly_attendance_data.overtime_days
                      ? Helper.currencyFormat(payslip.account.ot_rate) +
                        " Per hour"
                      : ""
                  }})</strong
                >
              </p>
              <p class="text-left mx-4 font-weight-medium">
                Late Marks :
                <strong>{{
                  payslip.monthly_attendance_data.late_marks || "-"
                }}</strong>
              </p>
            </v-col>
            <v-col cols="12">
              <p class="text-left mx-4">Note : Attendance data cannot be edited. To rectify any information, kindly delete and regenrate the paylsip for this employee for the given month.</p>
            </v-col>
          </v-row>

          <v-divider class="mx-4"></v-divider>

            <v-form v-model="payslipForm" ref="payslipForm"> 
          <v-row>
            <v-col cols="12" class="my-2">
              <h2 class="text-left mx-4 font-weight-medium">
                Earnings
                <v-icon dense @click="openDialog('E')">
                  mdi-plus-circle
                </v-icon>
              </h2>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col
              cols="12"
              md="3"
              class="py-1 text--left"
              v-for="transaction in payslip.payslip_transactions.filter(
                (t) => t.particular.particular_type == 'E'
              )"
              :key="transaction.id"
            >
              <v-text-field
                outlined
                dense
                :label="transaction.particular.title"
                class="mx-4 rounded-input"
                type="number"
                hide-details="auto"
                v-model="transaction.amount"
                :rules="[rules.no_negative, rules.required]"
              >
              </v-text-field>
            </v-col>
            <v-col
              cols="12"
              md="3"
              class="py-1 text--left"
              v-for="transaction in payslip.payslip_dynamic_transactions.filter(
                (t) => t.particular.particular_type == 'E'
              )"
              :key="transaction.id"
            >
              <v-text-field
                outlined
                dense
                :label="transaction.particular.title"
                class="mx-4 rounded-input"
                type="number"
                :append-outer-icon="transaction.particular.dynamic ? `mdi-delete`: null"
                @click:append-outer="deleteDynamicParticular(transaction)"
                hide-details="auto"
                v-model="transaction.amount"
                :rules="[rules.no_negative, rules.required]"
              >
              </v-text-field>
            </v-col>
          </v-row>
          
          <h3 class="text-left mx-4 my-2 green--text font-weight-medium">
            Total Earnings : {{ Helper.currencyFormat(findTotalEarnings()) }}
          </h3>

          <v-divider class="mx-4"></v-divider>


          <v-row no-gutters>
            <v-col class="my-2">
              <h2 class="text-left mx-4 font-weight-medium">
                Deductions
                <v-icon dense @click="openDialog('D')">
                  mdi-plus-circle
                </v-icon>
              </h2>
            </v-col>
          </v-row>

          <v-row no-gutters>
            <v-col
              cols="12"
              md="3"
              class="py-1 text--left"
              v-for="transaction in payslip.payslip_transactions.filter(
                (t) => t.particular.particular_type == 'D'
              )"
              :key="transaction.id"
            >
              <v-text-field
                outlined
                dense
                :label="transaction.particular.title"
                class="mx-4 rounded-input"
                v-model="transaction.amount"
                hide-details="auto"
                type="number"
                :rules="[rules.no_negative, rules.required]"
              >
              </v-text-field>
            </v-col>
            <v-col
              cols="12"
              md="3"
              class="py-1 text--left"
              v-for="transaction in payslip.payslip_dynamic_transactions.filter(
                (t) => t.particular.particular_type == 'D'
              )"
              :key="transaction.id"
            >
              <v-text-field
                outlined
                dense
                :label="transaction.particular.title"
                class="mx-4 rounded-input"
                :append-outer-icon="transaction.particular.dynamic ? `mdi-delete`: null"
                @click:append-outer="deleteDynamicParticular(transaction)"
                v-model="transaction.amount"
                hide-details="auto"
                type="number"
                :rules="[rules.no_negative, rules.required]"
              >
              </v-text-field>
            </v-col>
          </v-row>

          <h3 class="text-left mx-4 my-2 red--text font-weight-medium">
            Total Deductions :
            {{ Helper.currencyFormat(findTotalDeductions()) }}
          </h3>

          <v-divider class="mx-4"></v-divider>
          </v-form>


          <h3 class="text-left mx-4 my-2 font-weight-medium">
            <strong>
                            Net Salary :    
            {{ Helper.currencyFormat(findNetSalary()) }}

            </strong>

          </h3>

          <v-row>
            <v-col class="py-1">
              
                <v-btn color="primary" :disabled="!payslipForm" class="my-4 mx-4" @click="savePayslip"> Generate </v-btn>

            </v-col>
          </v-row>

          <v-row class="my-3">
            <v-col cols="12" class="py-1">
              <p class="text-center mx-4">
                Once generated, the payslip status will change back to "Pending"
                in the Generated payslips. This cannot be further edited,
                unless rejected again.
              </p>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>

    <v-row justify="center">
      <ConfirmationDialog
        :title="`Add ${dynamicItem.particular.particular_type == 'E' ? 'Earning' : dynamicItem.particular.particular_type == 'D' ? 'Deduction' : 'Particular' }`"
        successText="Add"
        @successCallback="saveDynamicItem"
        failureText="Cancel"
        @failureCallback="closeDialog"
        :disableSuccessButton="!dynamicItemForm"
        :visible="dialog"
      >
        <slot>
          <v-form ref="dynamicItemForm" v-model="dynamicItemForm">
            <v-text-field
              v-model="dynamicItem.particular.title"
              class="rounded-input mx-5"
              outlined
              dense
              :rules="[rules.required]"
              label="Title"
            />
          </v-form>
        </slot>
      </ConfirmationDialog>
    </v-row>

    <!-- snackbar -->
    <v-snackbar v-model="snackbar.visible" :color="snackbar.color" multi-line>
      {{ snackbar.text }}
      <template v-slot:action="{ attrs }">
        <v-btn dark text v-bind="attrs" @click="snackbar.visible = false"
          >Close</v-btn
        >
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import endpoints from "@api/repository";
import api from "@api/index";
import Helper from "@utils/misc";
import ConfirmationDialog from "@components/widgets/dialogs/ConfirmationDialog";
import moment from "moment";

export default {
  name: "EditEmployeePayslip",
  components: {
    ConfirmationDialog,
  },
  data() {
    return {
      rules: {
        required: (v) => !!v || "Required",
        no_negative: (value) => value >= 0 || "Invalid",
      },
      dialog: false,
      // Dynamic Particular
      dynamicItem: {
        //get GUID or db id (required for template slots)
        id: null,
        particular: {
            title: null,
            particular_type: null,
            payslip_group: null,
            dynamic: true,
        }
      },
      snackbar: {
        visible: false,
        text: "",
        color: "dark",
      },
      payslipForm: false,
      dynamicItemForm: false,
      payslip: null,
      Helper: Helper,
      moment: moment,
    };
  },
  computed: {
    ...mapGetters([
      "currentUser",
      "currentInstitution",
      "accessToken",
      "isLoading",
    ]),
    essentials() {
      return {
        accessToken: this.accessToken,
        setLoading: this.setLoading,
        handleErrorsFunction: this.handleApiErrors,
      };
    },
  },
  methods: {
    ...mapActions(["setLoading"]),
    openDialog(category) {
      this.dynamicItem.id = Helper.guidGenerator()
      this.dynamicItem.particular.particular_type = category;
      this.dialog = true;

    },

    // saveItem() {
    //   var temp = {};
    //   temp.title = this.AddItem.title;
    //   temp.amount = null;
    //   if (this.category == "Earning") {
    //     this.$set(this.emp.earnings, this.emp.earnings.length, temp);
    //   } else {
    //     this.$set(this.emp.deductions, this.emp.deductions.length, temp);
    //   }

    //   this.closeDialog();
    // },

    saveDynamicItem(){
        this.payslip.payslip_dynamic_transactions.push(Helper.clone(this.dynamicItem))
        this.closeDialog();
    },

    deleteDynamicParticular(transaction){
        this.payslip.payslip_dynamic_transactions = this.payslip.payslip_dynamic_transactions.filter((t) => t.id != transaction.id)
    },

    closeDialog() {
      this.dialog = false;
      this.dynamicItem.particular.particular_type = null
      this.dynamicItem.particular.title = null
      this.$refs.dynamicItemForm.reset();
    },

    findTotalDeductions() {
      var deduction_particulars = this.payslip.payslip_transactions.filter(
        (transaction) => transaction.particular.particular_type == "D"
      );
      var dynamic_deduction_particulars = this.payslip.payslip_dynamic_transactions.filter(
        (transaction) => transaction.particular.particular_type == "D"
      );

      var total_particulars_deduction = Helper.totalSum(
        deduction_particulars,
        "amount"
      );
      var total_dynamic_particulars_deduction = Helper.totalSum(
        dynamic_deduction_particulars,
        "amount"
      );

      var total_deductions =
        total_particulars_deduction + total_dynamic_particulars_deduction;
      return total_deductions;
    },

    findTotalEarnings() {
      var earning_particulars = this.payslip.payslip_transactions.filter(
        (transaction) => transaction.particular.particular_type == "E"
      );
      var dynamic_earning_particulars = this.payslip.payslip_dynamic_transactions.filter(
        (transaction) => transaction.particular.particular_type == "E"
      );

      var total_particulars_earning = Helper.totalSum(
        earning_particulars,
        "amount"
      );
      var total_dynamic_particulars_earning = Helper.totalSum(
        dynamic_earning_particulars,
        "amount"
      );

      var total_earnings =
        total_particulars_earning + total_dynamic_particulars_earning;
      return total_earnings;
    },

    findNetSalary() {
      var total_earnings = this.findTotalEarnings();
      var total_deductions = this.findTotalDeductions();
      return total_earnings - total_deductions;
    },

    async savePayslip(){
        var url = endpoints.payslip + `${this.payslip_id}/`
        let put_body = {
            "payslip" : this.payslip
        }
        var response = await api.call(this.essentials, url, api.Methods.PATCH,put_body)
        // console.log(response);
        if(response){
            this.snackbar.text = "Payslip Update and moved to pending"
            this.snackbar.visible = true;
            let self = this;
            setTimeout(function(){
                self.$router.push({ name: "PendingPayslips", params: { payroll_group: response.payroll_group, selected_payslip_group: response.payslip_group  } });
            },1000);
        }
    },

    async getPayslipData() {
      var url = Helper.addUrlParams(endpoints.payslip, [
        `id=${this.payslip_id}`,
      ]);
      var response = await api.call(this.essentials, url);
      if (response.approved == false) {
        this.payslip = response;
      } else {
        this.$router.push({ name: "PayrollDashboard" });
      }
    },
  },
  created() {
    if (this.$route.params.payslip_id != undefined) {
      this.payslip_id = this.$route.params.payslip_id;
      this.getPayslipData();
    } else {
      this.$router.push({ name: "PayrollDashboard" });
    }
  },
};
</script>

<style scoped>
.left-align {
  text-align: left;
}
</style>